import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { get, map, filter, concat, includes, flatten } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";

import CustomInput from "./CustomInput";
import CustomSelect from "./CustomSelect";

import { getAttributeName } from "../../utils/attributes";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";
import { ZONE_ATTR, ZONE_RESPONSIBILITY_CENTER_OPTIONS } from "../../constants/zones";

const styles = {
  dataBlock: {
    marginBottom: "10px",
    maxWidth: "100%",
  },
  errorMsg: {
    marginLeft: "0px",
    marginTop: "3px",
    marginBottom: "-15px",
  },
  rootCheckbox: {
    padding: "0px 9px 0px 0px",
  },
};

const FormSection = (props) => {
  const {
    classes,
    formValue,
    setFormValue,
    title,
    title2,
    id,
    type = "input",
    options = {},
    attribute,
    permission = false,
    onBlurHandler,
  } = props;

  const selectAll = () => {
    if (options.categories) {
      return flatten(
        map(get(options, ["options"]), (opt) => map(opt.options, (o) => o.id))
      );
    }

    return map(get(options, ["options"]), (opt) => opt.id);
  };

  if (type === "boolean") {
    return (
      <Grid
        item
        container
        alignItems="center"
        className={classes.dataBlock}
        style={{ ...props.style, marginBottom: props.noMarginBottom ? 0 : "" }}
      >
        <Checkbox
          color="primary"
          checked={get(formValue, [0]) || false}
          classes={{ root: classes.rootCheckbox }}
          onChange={(event) => {
            setFormValue(id, 0, event.target.checked);
          }}
        />
        {!props.noLabel && (
          <Box className="text-87 bold-500" style={{ display: "flex" }}>
            {get(attribute, ["id"])
              ? getAttributeName(get(attribute, ["id"]))
              : title2
              ? title2
              : I18n.get("profiles_" + title)}
          </Box>
        )}
      </Grid>
    );
  }

  return (
    <Grid
      item
      className={classes.dataBlock}
      style={{
        ...props.style,
        marginBottom: props.noMarginBottom ? 0 : "",
      }}
    >
      {!props.noLabel && (
        <Box
          className={clsx("text-87 bold-500", props.labelClass)}
          style={{ display: "flex" }}
        >
          {(options.required || get(attribute, ["required"])) && (
            <span style={{ color: colors.errorRed, paddingRight: "3px" }}>
              {"* "}
            </span>
          )}
          {options.startImg && (
            <img
              style={{
                marginRight: "7px",
                marginBottom: "2px",
                maxHeight: "20px",
                maxWidth: "40px",
              }}
              src={options.startImg}
              alt="icon"
            />
          )}
          {get(attribute, ["id"])
            ? getAttributeName(get(attribute, ["id"]))
            : title2
            ? title2
            : I18n.get("profiles_" + title)}
          {options.img && (
            <img style={{ marginLeft: "7px" }} src={options.img} alt="icon" />
          )}
          {id == 291 && options.msgValue && (
            <Box style={{ marginLeft: "5px" }}>{options.msgValue}</Box>
          )}
        </Box>
      )}
      {title === "ocrValues" && (
        <Box
          className="text-38 text-italic"
          style={{ marginBottom: "14px", fontSize: "0.875em" }}
        >
          {I18n.get("site_ocrValuesMsg")}
        </Box>
      )}
      {options.multipleSelect ? (
        <CustomSelect
          error={options.redBorder}
          name={title || id}
          value={formValue}
          options={options.options}
          onChange={(event) =>
            setFormValue(
              id,
              0,
              options.type === "bool"
                ? event.target.value === 1
                  ? true
                  : false
                : includes(get(event, ["target", "value"]), "selectAll")
                ? selectAll()
                : includes(get(event, ["target", "value"]), "selectNone")
                ? []
                : event.target.value
            )
          }
          selectAll={options.selectAll || false}
          multiple={options.multipleSelect || false}
          categories={options.categories || false}
          disabled={options.disabled || false}
          clickThrough={options.clickThrough || false}
          noSort={options.noSort || false}
          nullForAll={options.nullForAll || false}
          renderValue={(selected) => {
            return options.categories
              ? map(selected, (s) =>
                  get(
                    filter(
                      concat(...map(options.options, (o) => o.options)),
                      (o) => o.id === s
                    ),
                    [0, "name"]
                  )
                ).join(", ")
              : map(selected, (s) =>
                  get(
                    filter(options.options, (opt) => opt.id === s),
                    [0, "name"]
                  )
                ).join(", ");
          }}
        />
      ) : (
        formValue.map((item, index) => (
          <Grid
            container
            key={title + index}
            alignItems="center"
            style={{ marginBottom: props.noMarginBottom ? 0 : "16px" }}
          >
            {title === "ocrValues" && (
              <Grid item>
                <Checkbox
                  color="primary"
                  checked={item.mandatory_match || false}
                  style={{ padding: "0" }}
                  onChange={(event) =>
                    setFormValue(id, index, event.target.checked)
                  }
                />
              </Grid>
            )}
            <Grid
              item
              style={{
                width:
                  title === "ocrValues"
                    ? "180px"
                    : options.multiple
                    ? "calc(100% - 25px)"
                    : "100%",
                margin: options.multiple ? "0px 5px 0px 0px" : "0px",
              }}
            >
              {type === "select" ? (
                <CustomSelect
                  error={options.redBorder && !item}
                  name={`${id || title || title2}${index}`}
                  value={options.multipleSelect ? formValue : item || ""}
                  options={options.options}
                  disabled={options.disabled || false}
                  onChange={(event) =>
                    setFormValue(
                      id,
                      index,
                      options.type === "bool"
                        ? event.target.value === 1
                          ? true
                          : false
                        : event.target.value
                    )
                  }
                  multiple={options.multipleSelect || false}
                  categories={options.categories || false}
                  comboBox={options.comboBox || false}
                  noSort={options.noSort || false}
                  color={options.color || false}
                  clickThrough={options.clickThrough || false}
                  onClose={props.onClose || false}
                />
              ) : get(attribute, ["data_type"]) === "boolean" ? (
                <Checkbox
                  color="primary"
                  checked={item || false}
                  style={{ padding: "0" }}
                  onChange={(event) =>
                    setFormValue(id, index, event.target.checked)
                  }
                />
              ) : get(attribute, ["id"]) === ZONE_ATTR.RESPONSIBILITY_CENTER ?
                <CustomSelect
                  error={options.redBorder && !item}
                  name={id.toString()}
                  value={item || ""}
                  options={ZONE_RESPONSIBILITY_CENTER_OPTIONS}
                  disabled={options.disabled || false}
                  onChange={(event) =>
                    setFormValue(
                      id,
                      index,
                      event.target.value
                    )
                  }
                />
              : (
                <CustomInput
                  id={id.toString()}
                  error={options.redBorder}
                  helperText={options.errorMsg}
                  startAdornment={props.startAdornment}
                  endAdornment={props.endAdornment}
                  name={id.toString()}
                  permission={permission || options.disabled || false}
                  value={item || ""}
                  onChange={(event) =>
                    setFormValue(
                      id,
                      index,
                      options.type === "number" ||
                        ["integer"].includes(get(attribute, ["data_type"]))
                        ? parseInt(event.target.value)
                        : ["double", "float"].includes(
                            get(attribute, ["data_type"])
                          )
                        ? parseFloat(event.target.value)
                        : event.target.value
                    )
                  }
                  multiline={
                    options.multiline ||
                    get(attribute, ["data_type"]) === "multitext" ||
                    false
                  }
                  placeholder={options.placeholder}
                  autocomplete={options.autocomplete}
                  autoFocus={options.autoFocus}
                  rows={
                    get(attribute, ["data_type"]) === "multitext"
                      ? 5
                      : options.rows || null
                  }
                  height={options.height || null}
                  type={
                    ["integer", "float", "double"].includes(
                      get(attribute, ["data_type"])
                    )
                      ? "number"
                      : options.type || "text"
                  }
                  FormHelperTextProps={{
                    classes: { root: classes.errorMsg },
                  }}
                  onBlur={onBlurHandler}
                />
              )}
            </Grid>
            {
              // OCR TYPES
              title === "ocrValues" && (
                <Grid
                  item
                  style={{ margin: "0px 5px 0px 0px", width: "180px" }}
                >
                  <CustomSelect
                    name={title + index}
                    value={
                      item.attributes &&
                      item.attributes.filter((attr) => attr.id === 135).length >
                        0
                        ? item.attributes.filter((attr) => attr.id === 135)[0]
                            .value
                        : ""
                    }
                    options={options.options}
                    onChange={(event) =>
                      setFormValue(id, index, null, {
                        id: 135,
                        value: event.target.value,
                      })
                    }
                  />
                </Grid>
              )
            }
            {options.multiple && (
              <Grid item>
                <img
                  src={images.deleteIcon}
                  alt="delete"
                  style={{ cursor: "pointer" }}
                  onClick={() => setFormValue(id, index, null)}
                />
              </Grid>
            )}
          </Grid>
        ))
      )}
      {options.multiple && (
        <img
          src={images.plusIconColored}
          alt="add_value"
          style={{
            cursor: "pointer",
            marginLeft: title === "ocrValues" ? "25px" : "0px",
          }}
          onClick={() => setFormValue(id, formValue.length, "")}
        />
      )}
    </Grid>
  );
};

FormSection.propTypes = {
  formValue: PropTypes.array.isRequired,
  setFormValue: PropTypes.func.isRequired,
  onBlurHandler: PropTypes.func,
  title: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(["input", "select"]),
  options: PropTypes.shape({
    msgValue: PropTypes.string,
    categories: PropTypes.bool,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    img: PropTypes.string,
    type: PropTypes.string,
    multiline: PropTypes.bool,
    rows: PropTypes.number,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any,
        name: PropTypes.string,
      })
    ),
  }),
};

export default withStyles(styles)(FormSection);
